import { Shield, Database, Globe } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

function SkeletonItem() {
  return (
    <div className="py-3 border-b last:border-0">
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-24" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-4 rounded-full" />
          <Skeleton className="h-4 w-20" />
        </div>
      </div>
    </div>
  );
}

function SectionHeader({ icon: Icon, title }: { icon: React.ComponentType<{ className?: string }>; title: string }) {
  return (
    <h5 className="font-medium text-foreground mb-2 flex items-center gap-2 mt-4 first:mt-0">
      <Icon className="h-4 w-4 text-primary" />
      {title}
    </h5>
  );
}

export function UrlCheckerSkeleton() {
  return (
    <div className="w-full max-w-xl mx-auto animate-fade-in">
      {/* Main Status Card Skeleton */}
      <div className="rounded-2xl border-2 p-6 md:p-8 mb-6 bg-muted/30 border-border">
        <div className="flex flex-col items-center text-center">
          <Skeleton className="rounded-full h-[72px] w-[72px] mb-4" />
          <Skeleton className="h-8 w-48 mb-2" />
          <Skeleton className="h-4 w-64 mb-4" />
          <Skeleton className="h-8 w-40 rounded-full" />
        </div>
      </div>


      {/* Details Section Skeleton */}
      <div className="bg-card rounded-xl border p-6">
        <div className="flex items-center gap-2 mb-4">
          <Database className="h-5 w-5 text-primary" />
          <Skeleton className="h-5 w-28" />
        </div>
        
        {/* Security Checks */}
        <SectionHeader icon={Shield} title="Security" />
        <div className="space-y-0">
          <SkeletonItem />
          <SkeletonItem />
          <SkeletonItem />
          <SkeletonItem />
        </div>

        {/* Domain Info */}
        <SectionHeader icon={Globe} title="Domain Information" />
        <div className="space-y-0">
          <SkeletonItem />
          <SkeletonItem />
        </div>
      </div>
    </div>
  );
}
